(function () {
  let vari = $('.product__title').attr('data-vari');

  if (vari !== 'set') {
    $('.product__title').addClass('is-single-item');
    setTimeout(() => {
      let disPer = $('.product-form__input--pill .option_desc b+i').last().text().replace('%', '');
      // console.log('disPer=', disPer);
      $('.gallery-top .badge--set span strong b').text(disPer);
    }, 500)

  } else {
    $('.product__title').addClass('is-set-item');
    $('.gallery-top .badge--set span i').text('(Bundle Deals)');
  }
})();